// Packing List 더미 데이터
export const DUMMY_PACKING_DATA = {
  invoiceNo: "202501200007",
  poNumber: "#20250115",
  invoiceDate: "January 31, 2025",
  shipper: {
    companyName: "Pittasoft Co., Ltd.",
    address: "(13488) ABN Tower 4F, 331, Pangyo-ro, Bundang-gu, Seongnam-si, Korea",
    tel: "82-31-8039-7789",
    fax: "82-31-8039-5253",
    taxId: "124-86-30890"
  },
  shipTo: {
    companyName: "Beijing Automotive Technology Co., Ltd",
    address: "No.88 Jianguo Road, Chaoyang District, Beijing, China",
    attn: "Mr. Wang Lei",
    tel: "+86 10 8529 6688",
    taxId: "110105MA01K2XN4X"
  },
  soldTo: {
    companyName: "BVC Trade LLC",
    address: "125363, Moscow, Internal area of the City, Yuzhnoe Tushino Municipal District Shodnenskaya Street h.56, Office I, Room 4-6.",
    attn: "Andrei Nosikov",
    tel: "+7 (903) 225 25 05",
    email: "pch@bvctrade.ru",
    taxId: "7733123456"
  },
  taxIdNumberOrEIN: "124-86-30890",
  paymentTerms: "by 100% T/T in advance in CNY",
  termsOfPrice: "FCA, Seoul Republic of Korea",
  portOfLoading: "Incheon Airport, Republic of Korea",
  finalDestination: "Beijing Capital International Airport, China",
  carrier: "Other",
  collect: true,
  sailingDate: "February 10, 2025",
  contract: "BVC-2025-Q1-001",
  remarks: "Handle with care - Electronic products",
  items: [
    {
      item: "DR590X-1CH Plus 32GB BVC",
      description: "Dashcam",
      quantity: 20,
      eaWeight: 6,
      eaSumWeight: 11,
      netWeight: 11.0,
      grossWeight: 12.0,
      cartonNo: "1",
      dimensions: { width: 64, depth: 36, height: 23 },
      cbm: 1
    },
    {
      item: "DR590X-2CH Plus 32GB BVC",
      description: "Dashcam",
      quantity: 40,
      eaWeight: 7,
      eaSumWeight: 26,
      netWeight: 26.0,
      grossWeight: 28.0,
      cartonNo: "2 ~ 3",
      dimensions: { width: 64, depth: 36, height: 23 },
      cbm: 1
    },
    {
      item: "DR770X-1CH 64GB BVC",
      description: "Dashcam",
      quantity: 20,
      eaWeight: 7,
      eaSumWeight: 13.5,
      netWeight: 13.5,
      grossWeight: 14.5,
      cartonNo: "4",
      dimensions: { width: 64, depth: 36, height: 23 },
      cbm: 1
    },
    {
      item: "DR770X-2CH 64GB BVC",
      description: "Dashcam",
      quantity: 20,
      eaWeight: 9,
      eaSumWeight: 17,
      netWeight: 17.0,
      grossWeight: 18.0,
      cartonNo: "5",
      dimensions: { width: 64, depth: 42, height: 23 },
      cbm: 1
    },
    {
      item: "DR970X-1CH Plus 64GB BVC",
      description: "Dashcam",
      quantity: 20,
      eaWeight: 7,
      eaSumWeight: 14.5,
      netWeight: 14.5,
      grossWeight: 15.5,
      cartonNo: "6",
      dimensions: { width: 64, depth: 36, height: 23 },
      cbm: 1
    },
    {
      item: "DR970X-2CH Plus 64GB BVC",
      description: "Dashcam",
      quantity: 20,
      eaWeight: 9,
      eaSumWeight: 18,
      netWeight: 18.0,
      grossWeight: 19.0,
      cartonNo: "7",
      dimensions: { width: 64, depth: 42, height: 23 },
      cbm: 1
    },
    {
      item: "DR590X-2CH Plus 32GB BVC",
      description: "Dashcam",
      quantity: 10,
      eaWeight: 6,
      eaSumWeight: 6,
      netWeight: 6.0,
      grossWeight: 7.0,
      cartonNo: "8",
      dimensions: { width: 64, depth: 36, height: 23 },
      cbm: 1
    },
    {
      item: "DR770X-2CH 64GB BVC",
      description: "Dashcam",
      quantity: 10,
      eaWeight: 8,
      eaSumWeight: 8,
      netWeight: 8.0,
      grossWeight: 9.0,
      cartonNo: "9",
      dimensions: { width: 64, depth: 42, height: 23 },
      cbm: 1
    },
    {
      item: "DR970X-2CH Plus 64GB BVC",
      description: "Dashcam",
      quantity: 10,
      eaWeight: 9,
      eaSumWeight: 8.5,
      netWeight: 8.5,
      grossWeight: 9.5,
      cartonNo: "9",
      dimensions: { width: 64, depth: 42, height: 23 },
      cbm: 1
    },
    {
      item: "DR970X Box-2CH Plus 64GB BVC",
      description: "Dashcam",
      quantity: 5,
      eaWeight: 1.5,
      eaSumWeight: 7.5,
      netWeight: 7.5,
      grossWeight: 8.5,
      cartonNo: "10",
      dimensions: { width: 64, depth: 36, height: 23 },
      cbm: 1
    },
    {
      item: "RC1-300F",
      description: "Rear Camera",
      quantity: 5,
      eaWeight: 1,
      eaSumWeight: 4,
      netWeight: 0.4,
      grossWeight: 0.5,
      cartonNo: "",
      dimensions: { width: 0, depth: 0, height: 0 },
      cbm: 0
    },
    {
      item: "BF-1",
      description: "CPL FILTER",
      quantity: 8,
      eaWeight: 0,
      eaSumWeight: 1,
      netWeight: 0.1,
      grossWeight: 0.2,
      cartonNo: "11",
      dimensions: { width: 28, depth: 21, height: 24 },
      cbm: 0
    },
    {
      item: "BTC-3A",
      description: "BlackVue Tamper-Proof Case for sedan, SUV",
      quantity: 10,
      eaWeight: 1,
      eaSumWeight: 9,
      netWeight: 0.9,
      grossWeight: 1.0,
      cartonNo: "",
      dimensions: { width: 0, depth: 0, height: 0 },
      cbm: 0
    },
    {
      item: "B-130X",
      description: "Parking mode accessories",
      quantity: 20,
      eaWeight: 2.3,
      eaSumWeight: 46,
      netWeight: 46.0,
      grossWeight: 50.0,
      cartonNo: "12 ~ 15",
      dimensions: { width: 50, depth: 25, height: 21 },
      cbm: 0
    }
  ],
  packageSummary: {
    totalCartons: "15CTN(S)",
    netWeight: 177.4,
    grossWeight: 192.7
  },
  signedBy: "Eric Lee"
};